









































import Vue, { PropType } from 'vue';

interface ListItem {
  status: string;
  ticket: string;
  booth: string;
  purchasedDate: string;
  expiration: string;
  period: string;
  buyer: string;
}

export default Vue.extend({
  name: 'GContractList',
  props: {
    listItems: {
      type: Array as PropType<ListItem[]>,
      default: () => [],
    },
  },
});
